module.exports = __webpack_public_path__ + "media/images/pie/pie_escudo_centro-a135f0b9fe060f06a93e2c6306f702e2.png";